<template>
  <a class="product-cart-link" href="#" @click="onClick">
    <span v-if="quantity && !open" class="product-cart-link__quantity">{{ quantity }}</span>
    <svg class="icon">
      <title>{{ title }}</title>
      <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#bag"></use>
    </svg>
    <span>{{ title }}</span>
  </a>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'product-cart-link',
  props: {
    title: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters('cart', ['open', 'quantity']),
  },
  methods: {
    onClick(event) {
      event.preventDefault();
      event.stopPropagation();

      this.$store.commit('cart/toggle', !this.open);
    },
  },
};
</script>

<style lang="scss">
@import './product-cart-link';
</style>
